<template>
  <div class="share-file-panel ma-0 p-1" >
    <v-card-text mb-2 style="padding: 0 !important;">
      <v-layout row wrap>
        <v-flex xs12>
          <v-menu
            :nudge-bottom="50"
            content-class="menu-xs-responsive"
            full-width
            :open-on-click="false"
            v-model="openMenu"
            :max-height="400"
          >
            <v-container slot="activator" class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <VTextFieldExtended
                    ref="searchUser"
                    name="search-user"
                    autocomplete="off"
                    :loading="searchLoading"
                    @focus.native="openMenu = true"
                    @input.native="openMenu = true"
                    @mousedown.native="openMenu = true"
                    @focusout.native="openMenu = false"
                    @blur="toggleFromInput"
                    @keydown.native.enter="toggleFromInput"
                    class="pb-0"
                    v-model="searchInputValue"
                    :label="$tf('Recipients')"
                    prepend-icon="email"
                    required
                  />
                </v-flex>
              </v-layout>
            </v-container>

            <template v-if="searchInputValue.length">
              <v-list v-if="results.length > 0" two-line class="search-result py-0">
                <template v-for="(item, index) in results">
                  <v-divider
                    v-if="index > 0"
                    :key="(item.actor_id || item.email) + '-divider'"
                    :inset="!smallerThan('sm')"
                  />
                  <v-list-tile
                    avatar
                    href="#"
                    @mousedown.native.prevent="toggleItem(item)"
                    @keydown.native.enter="toggleItem(item)"
                    :key="item.actor_id || item.email"
                  >
                    <template v-if="item.shareType === 'guest'">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.email" />
                        <v-list-tile-sub-title>{{$tf('WarningSharingWithGuest')}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-avatar>
                        <provisional-avatar :item="item"></provisional-avatar>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <template>
                          <template>
                            <v-list-tile-title v-html="item.name" />
                          </template>
                          <v-list-tile-sub-title
                            v-if="item.additional_info"
                          >{{item.additional_info}}</v-list-tile-sub-title>
                        </template>
                      </v-list-tile-content>
                    </template>
                  </v-list-tile>
                </template>
              </v-list>

              <v-list v-else>
                <v-list-tile>
                  <v-list-tile-content>{{$tf('No results')}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </template>
          </v-menu>
          <v-container class="mt-3 mb-3 share-with-container">
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs3>
                    <label class="body-2">{{$tf('Share with')}}:</label>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6>
                    <v-layout row wrap align-start mt-1>
                      <v-spacer></v-spacer>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="items mt-2">
                  <v-chip v-if="selected.length === 0" class="reserve-chip">placeholder</v-chip>
                    <v-chip
                      close
                      v-for="item in selected"
                      :key="item.actor_id || item.email"
                      @input="toggleItem(item)"
                    >
                      <div v-if="item.shareType === 'guest'" class="name-chip">{{item.email}}</div>
                      <template v-else>
                        <provisional-avatar :item="item" font-size="20"></provisional-avatar>
                        <div v-if="item.name" class="name-chip">{{item.name}}</div>
                        <div v-else class="name-chip">{{item.email}}</div>
                      </template>
                    </v-chip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card-text>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Validator } from 'vee-validate/dist/vee-validate'
import Api from '~/store/idonia-api/api.js'
import ProvisionalAvatar from '~/components/common/ProvisionalAvatar.vue'
import SharedWithActions from '~/components/common/share/SharedWithActions.vue'
import VTextFieldExtended from '~/components/vuetify/VTextFieldExtended.vue'
import { debounce } from 'lodash'

export default {
  name: 'share-private',
  components: { SharedWithActions, ProvisionalAvatar, VTextFieldExtended },
  props: {
    file: {
      type: Object,
      required: null
    },
    sharedWith: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      searchLoading: false,
      searchInputValue: '',
      selected: [],
      results: [],
      $validator: null,
      message: '',
      openMenu: false
    }
  },
  created () {
    this.$validator = new Validator()
    this.$validator.attach({
      name: 'email',
      rules: 'required|email'
    })
    window.addEventListener('resize', () => {
      this.$forceUpdate()
    })
  },
  methods: {
    dedupeApiResults (apiResults) {
      const deduped = []
      const seen = new Set()
      apiResults.forEach(item => {
        const key = item.actor_id || item.email
        if (key && !seen.has(key)) {
          seen.add(key)
          deduped.push(item)
        }
      })
      return deduped
    },
    itemType (item) {
      return item.actor_id.split('/')[0]
    },
    itemID (item) {
      return item.actor_id.split('/')[1]
    },
    searchUser (match) {
      return new Promise((resolve, reject) => {
        if (!match || match.trim() === '') {
          return
        }
        Api.getV2('account-contacts', { match })
          .then(response => {
            if (
              response &&
              response.body &&
              response.body.constructor === Array
            ) {
              resolve(response.body)
            }
            reject(response)
          })
          .catch(reject)
      })
    },
    toggleItem (item) {
      this.searchInputValue = ''
      this.openMenu = false
      this.results = []
      const indexOfItem = this.selected.findIndex(selectedItem => {
        return selectedItem.shareType === 'guest'
          ? selectedItem.email === item.email
          : selectedItem.actor_id === item.actor_id
      })

      if (indexOfItem === -1) {
        this.selected.push(item)
      } else {
        this.selected.splice(indexOfItem, 1)
      }
    },
    toggleFromInput () {
      const value = (this.searchInputValue || '').trim()
      if (!value) {
        return
      }
      if (this.results && this.results.length === 1) {
        this.toggleItem(this.results[0])
      }
    }
  },
  computed: {
    ...mapGetters({
      smallerThan: 'viewport/smallerThan'
    }),
    selectedUsers () {
      return this.selected.map(item => item.actor_id || item.email)
    },
    accountOwner () {
      return this.file && this.file.account_owner
        ? this.file.account_owner
        : {}
    }
  },
  watch: {
    searchInputValue: debounce(async function (value) {
      if (!value || value.trim() === '') {
        this.results = []
        return
      }

      const currentSearchTerm = value
      this.searchLoading = true

      try {
        let apiResults = []
        try {
          apiResults = await this.searchUser(value)
        } catch (error) {
          apiResults = []
        }

        if (this.searchInputValue !== currentSearchTerm) {
          return
        }
        const selectedIds = this.selectedUsers
        const dedupedApiResults = this.dedupeApiResults(apiResults)
        let processedResults = dedupedApiResults
          .filter(
            item =>
              this.selectedUsers.indexOf(item.actor_id) === -1 &&
              this.itemID(item) !== this.accountOwner.account_uuid
          )
          .map(item => ({
            ...item,
            shareType: item.actor_id.split('/')[0]
          }))

        if (processedResults.length === 0) {
          const isValid = await this.$validator.validate('email', value)
          if (this.searchInputValue !== currentSearchTerm) {
            return
          }

          const hasApiSelected = dedupedApiResults.some(item => item.actor_id && selectedIds.indexOf(item.actor_id) !== -1)
          const emailAlreadySelected = selectedIds.indexOf(value) !== -1
          if (isValid && !emailAlreadySelected && !hasApiSelected) {
            processedResults.push({ email: value, shareType: 'guest' })
          }
        }

        this.results = processedResults
      } catch (error) {
        if (this.searchInputValue === currentSearchTerm) {
          this.results = []
        }
      } finally {
        if (this.searchInputValue === currentSearchTerm) {
          this.searchLoading = false
        }
      }
    }, 700),
    selected (value) {
      const accountItems = this.selected.map(item => ({
        id: item.actor_id || item.email,
        name: item.shareType === 'guest' ? item.email : (item.name || ''),
        type: item.shareType
      }))
      this.$emit('input', accountItems)
    }
  }
}

</script>

<style lang="scss" scoped>
.share-with-container.is-empty .share-with-content {
  visibility: hidden;
}

.share-with-container .reserve-chip {
  visibility: hidden;
}

.share-with-container.is-empty {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/account/ContactsInput.vue